import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'

import { ConfigContainer } from 'components'
import { Title, Container, Text } from 'components/Form'
import { librarian, message } from 'state_management'
import useT from 'utils/hooks/useT'
import { AiOutlineExclamation } from 'react-icons/ai'


export default function ChatbotConfig({ customerAdminView = false, chatbotData, onCancel }) {
  const { t } = useT("messages")
  const { t: tc } = useT("common")
  const dispatch = useDispatch()

  const [name, setName] = useState(chatbotData ? chatbotData.name : "")
  const [systemPrompt, setSystemPrompt] = useState(chatbotData ? chatbotData.systemPrompt : "")
  const role = useSelector((state) => state.auth.role)

  const onSubmit = () => {
    const input = { name, systemPrompt }
    if (systemPrompt.length > 1200) {
      return dispatch(message.error(t("adhoc.promptTooLong")))
    }
    if (name.length > 100) {
      return dispatch(message.error(t("adhoc.nameTooLong")))
    }
    if (chatbotData) {
      if (role !== "planner") {
        return dispatch(librarian.editAdminChatbot(chatbotData.id, input)).then(onCancel)
      } else {
        dispatch(librarian.editChatbot(chatbotData.id, input)).then(onCancel)
      }
    } else {
      if (role !== "planner") {
        if (customerAdminView) {
          return dispatch(librarian.createGlobalChatbot(input)).then(onCancel)
        } else {
          return dispatch(librarian.createAdminChatbot(input)).then(onCancel)
        }
      } else {
        dispatch(librarian.createChatbot(input)).then(onCancel)
      }
    }
  }
  return (
    <ConfigContainer
      title={chatbotData ? tc("editChatbot") : tc("createChatbot")}
      submitHandler={onSubmit}
      cancelHandler={onCancel}
      keyWordForAllowedDeletion="DELETE"
      deleteHandler={chatbotData ? (allowDeletion) => {
        if (allowDeletion === "DELETE") {
          if (chatbotData) {
            dispatch(librarian.deleteChatbot(chatbotData.id)).then(onCancel)
          }
        } else {
          dispatch(message.info(t("adhoc.didNotSpellDeleteProperly")))
        }
      } : undefined}
    >
      <Container>
        <Title>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <span>{tc("chatbotName")}</span>
            {name.length > 100 && (
              <AiOutlineExclamation
                style={{ color: "red", marginTop: "4px" }}
                size={40}
                title={tc("nameTooLongTitle")}
              />
            )}
          </div>
        </Title>
        <Text value={name} required onChange={setName} />
      </Container>
      <Container>
        <Title>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <span>{tc("systemPrompt")}</span>
            {systemPrompt.length > 1200 && (
              <AiOutlineExclamation
                style={{ color: "red", marginTop: "4px" }}
                size={40}
                title={tc("promptTooLongTitle")}
              />
            )}
          </div>
        </Title>
        <Text placeholder={tc("chatbotPlaceholder")}
        large={true} value={systemPrompt} onChange={setSystemPrompt} />
      </Container>
    </ConfigContainer>
  )
}
